import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface LoadingRecommendationsProps {
  className?: string;
}

const SUBTITLES = [
  "Buscando os melhores ativos...",
  "Analisando setup de filtros...",
  "Calculando scores de recomendação...",
  "Preparando sua curadoria personalizada...",
];

export function LoadingRecommendations({
  className,
}: LoadingRecommendationsProps) {
  const [currentSubtitleIndex, setCurrentSubtitleIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);

      setTimeout(() => {
        setCurrentSubtitleIndex((prev) => (prev + 1) % SUBTITLES.length);
        setIsVisible(true);
      }, 250);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="fixed inset-0 z-50 bg-transparent select-none" />
      <div
        className={cn(
          "fixed inset-0 z-50 flex items-center justify-center bg-gray-100/10 backdrop-blur-sm select-none",
          className,
        )}
      >
        <div className="bg-[#F9E10D] rounded-2xl p-8 shadow-2xl max-w-md mx-8 text-center select-none">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 select-none">
            Gerando recomendações
          </h2>
          <div className="h-6 relative">
            <div
              className="transition-all duration-500 ease-in-out absolute inset-0 flex items-center justify-center"
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "translateX(0)" : "translateX(-10px)",
              }}
            >
              <p className="text-sm text-gray-800 text-center select-none">
                {SUBTITLES[currentSubtitleIndex]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
